export type AppLocale = 'zh-CN' | 'en-US';

export const APP_LOCALES: ReadonlyArray<{
  id: AppLocale;
  nativeLabel: string;
  englishLabel: string;
}> = [
  { id: 'zh-CN', nativeLabel: '简体中文', englishLabel: 'Chinese (Simplified)' },
  { id: 'en-US', nativeLabel: 'English', englishLabel: 'English' },
];

export const DEFAULT_LOCALE: AppLocale = 'zh-CN';

export const LOCALE_STORAGE_KEY = 'ortho-blader-locale';
